var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{
    name: 'm3_revision',
    params: {sequence_id: _vm.revisionId.sequenceProtoId, level_num: _vm.revisionId.number, level_id: _vm.revisionId.protoId, revision: _vm.revisionId.revision},
    query: _vm.queryObject,
  }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }